import styled from 'styled-components';

import { flexEnd } from '../../../style/reusableStyle';

export const Wrapper = styled.div`
  margin: 18px 0px 200px;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.white};
  max-width: 1000px;
  & .contents {
    margin-left: 30px;
  }
`;

export const PdfContainer = styled.div`
  margin-bottom: 30px;

  .text {
    margin-bottom: 30px;
  }
`;
export const CloseAdditionalWrapperStyled = styled.div`
  ${flexEnd(0)};

  & svg {
    cursor: pointer;
    path {
      stroke: red;
    }
  }
`;

export const Notes = styled.div`
  margin-bottom: 30px;
  .note-input {
    max-width: 550px;
    margin-bottom: 10px;
  }

  .text {
    margin-bottom: 10px;
  }
`;

export const ActionButton = styled.div`
  display: flex;
  gap: 30px;
`;
